var map = {
	"./bg.json": "./src/locales/bg.json",
	"./cs.json": "./src/locales/cs.json",
	"./da.json": "./src/locales/da.json",
	"./de.json": "./src/locales/de.json",
	"./el.json": "./src/locales/el.json",
	"./en copy.json": "./src/locales/en copy.json",
	"./en.json": "./src/locales/en.json",
	"./es.json": "./src/locales/es.json",
	"./et.json": "./src/locales/et.json",
	"./fi.json": "./src/locales/fi.json",
	"./fr.json": "./src/locales/fr.json",
	"./hr.json": "./src/locales/hr.json",
	"./hu.json": "./src/locales/hu.json",
	"./it.json": "./src/locales/it.json",
	"./lt.json": "./src/locales/lt.json",
	"./lv.json": "./src/locales/lv.json",
	"./mt.json": "./src/locales/mt.json",
	"./nl.json": "./src/locales/nl.json",
	"./pl.json": "./src/locales/pl.json",
	"./pt.json": "./src/locales/pt.json",
	"./ro.json": "./src/locales/ro.json",
	"./sk.json": "./src/locales/sk.json",
	"./sl.json": "./src/locales/sl.json",
	"./sv.json": "./src/locales/sv.json",
	"./tr.json": "./src/locales/tr.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";